import React from 'react';
import { StarIcon } from 'lucide-react';
import { rating, reviews } from '../data/site';
export function Reviews() {
  const [featured, ...others] = reviews;
  return <section aria-labelledby="avis-title" className="bg-white py-20 lg:py-28" data-id="element-95" data-mp="2hefa0ktwd302">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-96" data-mp="2mady07bbcizy">
        <div className="lg:col-span-6" data-id="element-97" data-mp="2rc3a7qa9v2pm">
          <h2 id="avis-title" className="sr-only" data-id="element-98" data-mp="2wa4olxwr6dur">
            Les avis de nos clients
          </h2>
          <div className="flex items-center gap-3" data-id="element-99" data-mp="30b83oi6z85ux">
            <div className="flex" aria-hidden data-id="element-100" data-mp="309ncn2jvf51t">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`h-5 w-5 ${i < 4 ? 'fill-ink text-ink' : 'text-ink'}`} data-id="element-101" data-mp="352q4n69026fw" />)}
            </div>
            <p className="text-sm text-muted" data-id="element-102" data-mp="3f0cqydsmp09w">
              <span className="font-bold text-ink" data-id="element-103" data-mp="3f1nrm4qs1rws">{rating.score}/5</span> sur {rating.count} avis
            </p>
          </div>
          <blockquote className="mt-8" data-id="element-104" data-mp="3jxcwmnlkg10h">
            <p className="font-serif text-4xl font-medium italic leading-tight text-ink lg:text-5xl" data-id="element-105" data-mp="2rd6z07xn04pr">
              « {featured.quote} »
            </p>
            <footer className="mt-6 text-muted" data-id="element-106" data-mp="2mc9jy47xbqsh">
              <span className="font-bold text-ink" data-id="element-107" data-mp="2hdy9psdpve9q">{featured.author}</span> · {featured.date}
            </footer>
          </blockquote>
        </div>

        <ul className="divide-y divide-line lg:col-span-6 lg:border-l lg:border-line lg:pl-16" data-id="element-108" data-mp="2depgqpqi3kf8">
          {others.map(r => <li key={r.author} className="py-7 first:pt-0 last:pb-0" data-id="element-109" data-mp="354c1riwaxd4b">
              <blockquote data-id="element-110" data-mp="35659l1ini3dw">
                <p className="leading-relaxed text-ink" data-id="element-111" data-mp="30d3scmuz1rr5">« {r.quote} »</p>
                <footer className="mt-3 text-sm text-muted" data-id="element-112" data-mp="30b93ixgkxfhs">
                  <span className="font-bold text-ink" data-id="element-113" data-mp="2wap5zss3g9v4">{r.author}</span> · {r.date}
                </footer>
              </blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}